import { api } from "../../services/Api.js";

export function get_teacher_talks_slots({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token

   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    //console.log('get_teacher_talk_slots')
    //console.dir(payload);
    // retrun chainable promise
    return api
    .post(school,"get_teacher_talks_slots.php",payload)
    .then( result =>{ 
      //console.dir(result)
      
      commit('SET_TEACHER_TALKS_SLOTS', {store_key:payload.store_key, slots:result.data});
      return result;
    })
    .catch( error => {
      //console.log("ERROR GETTING CALENDAR",error);
      return error;
    })

}